var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonalAccessBusiness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8613 22.2214H23.1283L19.8345 39.9973C19.9134 39.9985 19.9921 40 20.0689 40C25.6932 40 38.3612 37.0369 38.3612 37.0369C39.5943 35.7401 35.1113 22.2214 30.8613 22.2214ZM9.27385 22.2214C5.02443 22.2214 0.0739872 35.925 1.77527 37.0368C1.77527 37.0368 14.0993 39.9192 19.8345 39.9973L16.5408 22.2214C13.095 22.2214 9.27385 22.2214 9.27385 22.2214Z",
    fill: "url(#paint0_linear_3451_61114)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7146 9.62914C29.7146 4.31076 25.2908 0 19.8347 0C14.3772 0 9.9541 4.3108 9.9541 9.62914C9.9541 14.9468 14.3772 19.2587 19.8347 19.2587C25.2908 19.2587 29.7146 14.9468 29.7146 9.62914Z",
    fill: "url(#paint1_linear_3451_61114)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3451_61114",
    x1: 20.0003,
    y1: 22.2214,
    x2: 20.0003,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3451_61114",
    x1: 19.8344,
    y1: 0,
    x2: 19.8344,
    y2: 19.2587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalAccessBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/personal-Access-business.0ecae714c472e9f29cb46d406de4da39.svg";